<template>
  <sidebar
  :addTitle="$t('GradeControl.Location.AddNew')"
  :editTitle="$t('GradeControl.Location.Edit')"
  :isSidebarActive="isSidebarActive"
  :data="data"
  @onNewData="newData"
  @onEditData="editData"
  @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.Location.Code')" rules="required" v-slot="{ errors }">
              <validated-input
              :disabled="locationId !== 0"
              :label="$t('GradeControl.Location.Code')"
              v-model="locationCode"
            ></validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
           <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.Location.AlternateCodes')" v-slot="{ errors }">
              <validated-input
                :label="$t('GradeControl.Location.AlternateCodes')"
                v-model="locationAlternateCodes"
                name="alternateCodes"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.Location.Type')" rules="required" v-slot="{ errors }">
              <form-label>{{$t('GradeControl.Location.Type')}}</form-label>
              <v-select
                :label="$i18n.locale.startsWith('fr') ? 'nameFr' : 'nameEn'"
                :disabled="locationId !== 0"
                :options="locationTypes"
                :reduce="type => type.id"
                v-model="locationType"
                class="w-full"
              />
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3" v-if="useBucketInput">
          <vs-col vs-w="12">
            <ValidationProvider :name="$systemUnits.getDensityLabel()" :rules="'decimal:2|between:0,' + $systemUnits.convertDensity(100)" v-slot="{ errors }">
                <validated-input
                :label="$systemUnits.getDensityLabel()"
                v-model="locationDensity"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <vs-checkbox v-model="locationIsActive" class="mb-2">{{$t('GradeControl.Location.IsActive')}}</vs-checkbox>
          </vs-col>
        </vs-row>
        <vs-divider class="mb-0">{{$t('GradeControl.Location.Capping')}}</vs-divider>
        <vs-row class="mb-3" vs-type="flex" vs-justify="space-between">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('Gold')" rules="decimal:2" v-slot="{ errors }">
              <validated-input
                :label="$systemUnits.getCappingLabelNoPrefix('Gold')"
                v-model="locationGoldCapping"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-5" vs-type="flex" vs-justify="space-between">
          <vs-col vs-w="5" class="mr-5">
            <ValidationProvider :name="$t('Silver')" rules="decimal:2" v-slot="{ errors }">
              <validated-input
                :label="$systemUnits.getCappingLabelNoPrefix('Silver')"
                v-model="locationSilverCapping"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
          <vs-col vs-w="5">
            <ValidationProvider :name="$t('Copper')" rules="decimal:2|between:0,100" v-slot="{ errors }">
            <validated-input
              :label="$t('Copper')"
              v-model="locationCopperCapping"
            ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-5" vs-type="flex" vs-justify="space-between">
          <vs-col vs-w="5" class="mr-5">
            <ValidationProvider :name="$t('Zinc')" rules="decimal:2|between:0,100" v-slot="{ errors }">
            <validated-input
              :label="$t('Zinc')"
              v-model="locationZincCapping">
              </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
          <vs-col vs-w="5">
            <ValidationProvider :name="$t('Lead')" rules="decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('Lead')"
                v-model="locationLeadCapping"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>
import vSelect from 'vue-select';
import LocationTypeEnum from "../../../LocationTypeEnum.js";
import ElementEnum from "@/app/shared/ElementEnum.js";
import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "./../../../../../shared/components";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    vSelect,
    FormLabel,
    ValidatedInput,
    ValidationMessage,
    Sidebar
  },
  data() {
    return {
      locationId: 0,
      locationCode: "",
      locationAlternateCodes: "",
      locationDensity: 0,
      locationIsActive: true,
      locationType: LocationTypeEnum.Production,
      locationTypes: LocationTypeEnum.definition,
      locationGoldCapping : null,
      locationSilverCapping : null,
      locationCopperCapping : null,
      locationZincCapping : null,
      locationLeadCapping : null,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.closeSidebar();
        }
      }
    },
    useBucketInput() {
      return this.$store.getters.isProjectUsingBucketInput;
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const { locationId, code, alternateCodes, density, isActive, type, cappings } = JSON.parse(JSON.stringify(this.data));
      this.locationId = locationId;
      this.locationCode = code;
      this.locationAlternateCodes = alternateCodes;
      this.locationDensity = this.useBucketInput ? this.$systemUnits.convertDensity(density) : 0;
      this.locationType = type;
      this.locationIsActive = isActive;
      this.locationGoldCapping = this.$systemUnits.convertGrade(this.getCapping(cappings, ElementEnum.Gold));
      this.locationSilverCapping = this.$systemUnits.convertGrade(this.getCapping(cappings, ElementEnum.Silver));
      this.locationCopperCapping = this.getCapping(cappings, ElementEnum.Copper);
      this.locationZincCapping = this.getCapping(cappings, ElementEnum.Zinc);
      this.locationLeadCapping = this.getCapping(cappings, ElementEnum.Lead);
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.locationCode = "";
      this.locationAlternateCodes = "";
      this.locationId = 0;
      this.locationDensity = null;
      this.locationType = LocationTypeEnum.Production;
      this.locationGoldCapping = null;
      this.locationSilverCapping = null;
      this.locationCopperCapping = null;
      this.locationZincCapping = null;
      this.locationLeadCapping = null;
      this.locationIsActive = true;
    },
    getCapping(cappings, elementId) {
      if (cappings !== null) {
        const element = cappings.find(r => r.element === elementId)
        if (element) {
          return element.capping;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },

    defineCapping(elementId, locationId, capping, cappings) {
      if (capping !== null && capping !== '') {
        cappings.push({
          locationId,
          element : elementId,
          capping
        })
      }
    },
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            locationId: this.locationId,
            code: this.locationCode,
            alternateCodes: this.locationAlternateCodes,
            density: this.useBucketInput ? this.$systemUnits.convertDensityToMetric(this.locationDensity) : 0,
            type: this.locationType,
            projectId: this.projectId,
            isActive: this.locationIsActive,
            cappings: []
          };

          this.defineCapping(ElementEnum.Gold, this.locationId, this.$systemUnits.convertGradeToMetric(this.locationGoldCapping), obj.cappings);
          this.defineCapping(ElementEnum.Silver, this.locationId, this.$systemUnits.convertGradeToMetric(this.locationSilverCapping), obj.cappings);
          this.defineCapping(ElementEnum.Copper, this.locationId, this.locationCopperCapping, obj.cappings);
          this.defineCapping(ElementEnum.Zinc, this.locationId, this.locationZincCapping, obj.cappings);
          this.defineCapping(ElementEnum.Lead, this.locationId, this.locationLeadCapping, obj.cappings);

          this.$vs.loading();
          if (this.locationId !== null && this.locationId > 0) {
            this.$store.dispatch("gradeControl/updateLocation", obj).then((result) => {
              this.$emit("onLocationUpdated", result.data.model);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("gradeControl/addLocation", obj).then((result) => {
              this.$emit("onLocationInserted", result.data.model);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
